import { render } from "./ConfirmedEmail.vue?vue&type=template&id=5bbf9ad0&scoped=true"
import script from "./ConfirmedEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmedEmail.vue?vue&type=script&lang=js"

import "./ConfirmedEmail.vue?vue&type=style&index=0&id=5bbf9ad0&scoped=true&lang=css"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbf9ad0"]])

export default __exports__